import { render, staticRenderFns } from "./HintText.vue?vue&type=template&id=53e490cc"
import script from "./HintText.vue?vue&type=script&lang=js"
export * from "./HintText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports